module.exports = __webpack_public_path__ + "static/media/menu.c5beda48.svg";